module.exports = __webpack_public_path__ + "img/logo_white_background.b4cdbba1.png";